import { QueryKey, useMutation, useQueryClient } from "@tanstack/react-query";
import type { CrudType } from "../../utils/useCrud/CrudType";

export const getUseDelete =
  <TRequest extends CrudType, T extends CrudType>(
    queryKey: (item: TRequest) => QueryKey,
    sendDeleteItem: (id: TRequest) => Promise<boolean>,
    idKey: keyof T & keyof TRequest = "id"
  ) =>
  () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (id: TRequest) => sendDeleteItem(id),
      onMutate: async (item) => {
        await queryClient.cancelQueries(queryKey(item));
        queryClient.setQueryData(queryKey(item), (prevItems: T[] = []) =>
          prevItems.filter(
            (prevItem) =>
              (prevItem[idKey] as string | number) !==
              (item[idKey] as string | number)
          )
        );
      },
    });
  };
